module.exports = __webpack_public_path__ + "a6d8a96698e2973314bdaf0e4d2bc85b.woff2";